import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { IResponseError } from '../../store/helpers';
import { AxiosError } from 'axios';

interface IUseHandler {
  response?: any;
  error?: AxiosError;
  storeError?: IResponseError;
}

const getMsg = (response: any) => {
  return (
    response?.data?.message ||
    (typeof response?.data?.data === 'string' && response?.data?.data)
  );
};

export function useResponseFormHandler({
  response,
  error,
  storeError,
}: IUseHandler): void {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (response?.data) {
      const msg = getMsg(response);

      const responseMsg = msg || 'Success';
      enqueueSnackbar(responseMsg, { variant: 'success' });
    }
  }, [response, enqueueSnackbar]);

  useEffect(() => {
    const errStatus = error?.response?.status;
    if (errStatus) {
      if (errStatus === 422 || errStatus === 400 || errStatus === 404) {
        const msg = getMsg(error?.response);
        enqueueSnackbar(msg || 'Error', { variant: 'error' });
      } else if (errStatus === 500) {
        enqueueSnackbar('Something went wrong', { variant: 'error' });
      }
    }
  }, [error, enqueueSnackbar]);

  useEffect(() => {
    const errStatus = storeError?.statusCode;
    if (errStatus) {
      if (errStatus === 422 || errStatus === 400) {
        enqueueSnackbar(storeError?.data?.message, { variant: 'error' });
      } else if (errStatus === 500) {
        enqueueSnackbar('Something went wrong', { variant: 'error' });
      }
    }
  }, [storeError, enqueueSnackbar]);
}
